import { ChangeDetectionStrategy, Component, signal, computed } from '@angular/core';

@Component({
  selector: 'app-header-toast-message',
  templateUrl: './header-toast-message.component.html',
  styleUrls: ['./header-toast-message.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderToastMessageComponent {
  private readonly _toastBanners = signal<ToastBanner[]>([]);
  public readonly toastBanners = computed(() => this._toastBanners());

  public onActionClick(banner: ToastBanner): void {
    banner.action?.(banner.id ?? 0);
  }

  public addBanner(_banner: Partial<ToastBanner>): number {
    const currentBanners = this._toastBanners();
    const index = currentBanners.length;
    const banner: ToastBanner = { ..._banner, id: index };
    this._toastBanners.set([...currentBanners, banner]);
    return index;
  }

  public replace(_banner: Partial<ToastBanner>, id: number): number {
    const currentBanners = this._toastBanners();
    const banner = currentBanners.find((b: ToastBanner) => b.id === id);
    if (!banner) {
      return this.addBanner(_banner);
    }

    // Create a new banner with updated properties
    const updatedBanner = {
      ...banner,
      message: _banner.message,
      buttonText: _banner.buttonText,
      action: _banner.action,
    };

    // Replace the banner in the array
    this._toastBanners.set(currentBanners.map((b: ToastBanner) => (b.id === id ? updatedBanner : b)));
    return banner.id;
  }

  public removeBanner(id: number): void {
    this._toastBanners.set(this._toastBanners().filter((banner: ToastBanner) => banner.id !== id));
  }

  public removeAll(): void {
    this._toastBanners.set([]);
  }
}

export interface ToastBanner {
  message?: string;
  buttonText?: string;
  action?: (id: number) => void;
  id: number;
}
